import { VERSION } from "./version";

export const environment = {
	production: true,
	version: VERSION,
};
